export const API_KEY = 'AIzaSyBjoqk_zstzQ0rrTglfN58MGxlJf58aF5s';
